import "css/formDIShippingViewResponsive.css";
import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import TableSortingViewsPurchase from "pages/forms/filterFormDI/FormDIShippingView/SortingTablesFormDIShipping";
import ReportTemplateShipping from "pages/shipping/generatePDF/ReportTemplateShipping";
import PropTypes from 'prop-types';
import { PDFDocument } from 'pdf-lib';
const ShippingPdfCollector = React.memo(({
  dataShipping,
  onGenerated
}) => {
  const handlePdfGenerated = useCallback(blob => onGenerated(dataShipping.id, blob), [dataShipping.id, onGenerated]);
  return <ReportTemplateShipping dataShipping={dataShipping} setPdfBlob={handlePdfGenerated} />;
});
ShippingPdfCollector.displayName = 'ShippingPdfCollector';
ShippingPdfCollector.propTypes = {
  dataShipping: PropTypes.object.isRequired,
  onGenerated: PropTypes.func.isRequired
};
const initialStateShipping = [{
  id: "",
  ownshipping_id: "",
  defaultStore_id: 0,
  useraccount_id: 0,
  defaultformatnumber: 1,
  number_shipping: "",
  date_shipping: "",
  rel_trans_store_id: 0,
  rel_trans_documentid: "",
  rel_trans_tradename: "",
  rel_trans_street: "",
  vehiclestore_id: 0,
  vehiclestore_licenseplate: "",
  vehiclestore_documentid: "",
  vehiclestore_defaultdriver: "",
  vehiclestore_trailer: "",
  opt_tras_store_id: 0,
  opt_tras_documentid: "",
  opt_tras_tradename: "",
  opt_tras_street: "",
  dest_tras_store_id: 0,
  dest_tras_documentid: "",
  dest_tras_tradename: "",
  dest_tras_street: "",
  weight: 0,
  price_weight: 0,
  service_1: "",
  price_service_1: 0,
  service_2: "",
  price_service_2: 0,
  service_3: "",
  price_service_3: 0,
  destine_street: "",
  tax: 0,
  taxincluded: false,
  observations: "",
  signature_driver: "",
  signature_charger: "",
  signature_inspector: ""
}];
const FormDIShipping = ({
  openViewShipping,
  setOpenViewShipping,
  rowEditFormDI
}) => {
  const {
    t,
    i18n
  } = useTranslation(['listDataForms']);
  const LIMITPAGESIZE = useSelector(state => state.loginUser.defaultticketsformat.limitpagesize);
  const token = useSelector(state => state.loginUser.token);
  const roles = useSelector(s => s.loginUser.roles);
  const [dataShiping, setDataShiping] = useState(initialStateShipping);
  const [isLoadingErrorShipping, setIsLoadingErrorShipping] = useState(false);
  const isLoading = useSelector(state => state.loading.isLoading);
  const [numTotRegShipping, setNumTotRegShipping] = useState(0);
  const [activeOffsetShipping, setActiveOffsetShipping] = useState(false);
  const [currencyOffsetShipping, setCurrencyOffsetShipping] = useState(0);
  const [rangeOffsetShipping, setRangeOffsetShipping] = useState([{}]);
  const [pdfBlob, setPdfBlob] = useState(null);
  const [shippingPdfBlobs, setShippingPdfBlobs] = useState({});
  const dispatch = useDispatch();
  const menuPermissions = useMemo(() => {
    const list = roles?.[0]?.listmenus ?? [];
    const has = name => list.some(m => m.name === name);
    return {
      canViewPrice: has('View_Prices_Shipping'),
      canViewReference: has('View_Reference_Shipping'),
      canViewOptTras: has('View_OptTras_Shipping')
    };
  }, [roles]);
  const shippingIdsKey = useMemo(() => dataShiping.map(shipping => shipping.id).join(','), [dataShiping]);
  useEffect(() => {
    setShippingPdfBlobs({});
    setPdfBlob(null);
  }, [shippingIdsKey]);
  const handleShippingPdfGenerated = useCallback((shippingId, blob) => {
    setShippingPdfBlobs(previous => ({
      ...previous,
      [String(shippingId)]: blob
    }));
  }, []);
  useEffect(() => {
    const validShippings = dataShiping.filter(shipping => shipping?.id);
    if (validShippings.length === 0) return;
    const orderedBlobs = validShippings.map(shipping => shippingPdfBlobs[String(shipping.id)]);
    if (orderedBlobs.some(blob => !blob)) return;
    let cancelled = false;
    const mergeShippingPdfs = async () => {
      try {
        const mergedPdf = await PDFDocument.create();
        for (const blob of orderedBlobs) {
          const sourcePdf = await PDFDocument.load(await blob.arrayBuffer());
          const pages = await mergedPdf.copyPages(sourcePdf, sourcePdf.getPageIndices());
          pages.forEach(page => mergedPdf.addPage(page));
        }
        if (mergedPdf.getPageCount() !== validShippings.length) {
          throw new Error('No se han generado todas las cartas asociadas');
        }
        const mergedBytes = await mergedPdf.save();
        if (!cancelled) {
          setPdfBlob(new Blob([mergedBytes], {
            type: 'application/pdf'
          }));
        }
      } catch (error) {
        if (!cancelled) {
          setPdfBlob(null);
          dispatch(warningErrorAction(t('Text_IncorrectData')));
        }
      }
    };
    mergeShippingPdfs();
    return () => {
      cancelled = true;
    };
  }, [dataShiping, dispatch, shippingPdfBlobs, t]);
  const handleCloseDataViewShipping = () => {
    setDataShiping(initialStateShipping);
    setIsLoadingErrorShipping(false);
    dispatch(setLoading(false));
    setNumTotRegShipping(0);
    setActiveOffsetShipping(false);
    setCurrencyOffsetShipping(0);
    setRangeOffsetShipping([{}]);
    setPdfBlob(null);
    setShippingPdfBlobs({});
    setOpenViewShipping(false);
  };
  const PdfViewer = useMemo(() => {
    return pdfBlob ? <iframe src={`${URL.createObjectURL(pdfBlob)}#view=FitH`} title="PDF Preview" style={{
      width: '100%',
      height: '100%',
      border: 'none'
    }} /> : null;
  }, [pdfBlob]);
  useEffect(() => {
    let isMounted = true;
    const fetchnumTotRegShipping = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT, `form/getinformationshippingbyformId/`, token, rowEditFormDI.id);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            if (getData.message === "Load failed") {
              dispatch(warningErrorAction(t('Text_ConnectionFailied')));
            } else {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            }
          }
        } else if (isMounted) {
          setNumTotRegShipping(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData')));
        dispatch(setLoading(false));
      }
    };
    const fetchdataShiping = async () => {
      try {
        dispatch(setLoading(false));
        const getData = await helpHttp().get7(ENDPOINT, `form/getshippingbyformid`, token, currencyOffsetShipping, LIMITPAGESIZE, rowEditFormDI.id);
        if (getData.err) {
          dispatch(setLoading(false));
          setDataShiping(initialStateShipping);
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else {
          if (isMounted) {
            setDataShiping(getData);
          }
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    };
    if (openViewShipping) {
      fetchnumTotRegShipping();
      fetchdataShiping();
    }
    return () => {
      isMounted = false;
    };
  }, [t, i18n, token, dispatch, currencyOffsetShipping, openViewShipping, rowEditFormDI.id, LIMITPAGESIZE]);
  const toggleDrawerSearchFormDI = open => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataViewShipping();
    }
  };
  return <>
      {openViewShipping && <div>
          <SwipeableDrawer PaperProps={{ className: 'formdi-associated-shipping-panel', sx: { width: 'min(1150px, 100vw)', maxWidth: '100vw', minWidth: 0, overflowX: 'hidden' } }} anchor='right' open={true} onClose={toggleDrawerSearchFormDI(false)} onOpen={toggleDrawerSearchFormDI(true)}>
            <Container maxWidth={false} sx={{ width: "100%", minWidth: 0, px: 1 }}>
              <Box sx={{
            bgcolor: '#ffffff',
            width: '100%', minWidth: 0, maxWidth: '100%'
          }}>
                <div className="formdi-pending-header2"> 
                  <h1 className="formdi-pending-title">
                  {isLoadingErrorShipping ? <i className="fas fa-solid fa-exclamation fa-2x text-danger"></i> : isLoading ? <CircularProgress color={"primary"} /> : <i className="fas fa-regular fa-clipboard text-warning"></i>} {t('Text_FORM_NUM_DI') + ": " + rowEditFormDI.ownformdi_id}</h1>
                     <div>
                      <button type="button" className="formdi-pending-btn formdi-pending-btn--primary" onClick={handleCloseDataViewShipping}>{t('Button_Back')}</button><> </>
                    </div>  
                </div>  
                <br />  
                {!isLoading ? <>
                   <div className="formdi-pending-card-flat">
                      <div className="formdi-pending-card-content">
                      <TableSortingViewsPurchase dataShiping={dataShiping} titleTable={"Text_SHIPPING_Table"} numTotRegShipping={numTotRegShipping} activeOffsetShipping={activeOffsetShipping} rangeOffsetShipping={rangeOffsetShipping} currencyOffsetShipping={currencyOffsetShipping} setCurrencyOffsetShipping={setCurrencyOffsetShipping} showTotal={menuPermissions.canViewPrice} showReference={!menuPermissions.canViewReference} showOptTras={!menuPermissions.canViewOptTras}>
                      </TableSortingViewsPurchase>
                      </div>             
                    </div>
                    {/* PDF CARD */}
                    <div className="email-card-pdf">
                      {PdfViewer}
                    </div>
                     
                  {/* End Content Row */}
                  </> : <LoadingNews />} 
              </Box>
              {dataShiping.map(shipping => shipping?.id ? <ShippingPdfCollector key={shipping.id} dataShipping={shipping} onGenerated={handleShippingPdfGenerated} /> : null)}
            </Container>
          </SwipeableDrawer>
        </div>}  
    </>;
};
FormDIShipping.propTypes = {
  openViewShipping: PropTypes.bool.isRequired,
  setOpenViewShipping: PropTypes.func.isRequired
};
export default FormDIShipping;